import React, { useCallback, useEffect, useState } from 'react';
import Header from '../Header';
import { listManagedEmployees } from '../../api/reviewsManaged';
import { useNavigate } from 'react-router-dom';
import '../../components/reviews/reviews-table.css';

export default function TeamPerformanceReviewsIndex() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState('');
    const [employees, setEmployees] = useState([]);
    const [manager, setManager] = useState(null);
    const [q, setQ] = useState('');
    const [page, setPage] = useState(1);
    const [perPage] = useState(15);
    const [meta, setMeta] = useState({ current_page: 1, last_page: 1, total: 0 });

    const load = useCallback(async () => {
        try {
            setLoading(true);
            setErr('');
            const res = await listManagedEmployees({
                q: q || undefined,
                page,
                per_page: perPage,
            });
            setEmployees(res.employees || []);
            setManager(res.manager || null);
            setMeta(res.meta || { current_page: page, last_page: page, total: res.employees?.length ?? 0 });
        } catch (e) {
            setErr(e?.response?.data?.message || 'Failed to load employees.');
        } finally {
            setLoading(false);
        }
    }, [page, perPage, q]);

    useEffect(() => { load(); }, [load]);

    const canPrev = meta.current_page > 1;
    const canNext = meta.current_page < meta.last_page;

    return (
        <>
            <Header label={<p className="py-0 my-0">Team Performance Reviews</p>} />
            <main id="main" className="main">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-header d-flex align-items-center gap-2">
                                <div className="d-flex flex-column">
                                    <h5 className="mb-0">Direct Reports</h5>
                                    <small className="text-white small">
                                        {manager ? `Manager: ${manager.name}` : ''}
                                    </small>
                                </div>

                                <div className="ms-auto d-flex gap-2">
                                    <input
                                        className="form-control form-control-sm"
                                        placeholder="Filter by name or email…"
                                        style={{ width: 300 }}
                                        value={q}
                                        onChange={e => { setPage(1); setQ(e.target.value); }}
                                    />
                                </div>
                            </div>

                            <div className="card-body">
                                {err && <div className="alert alert-danger">{err}</div>}
                                {loading ? (
                                    <div className="text-muted">Loading…</div>
                                ) : (
                                    <>
                                        <div className="table-responsive reviews-table reviews-table--zebra">
                                            <table>
                                                <thead>
                                                <tr className="rt-head-top">
                                                    <th className="rt-name">Employee #</th>
                                                    <th>Name</th>
                                                    <th>Surname</th>
                                                    <th>Email</th>
                                                    <th className="rt-actions text-end">Actions</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {employees.length === 0 && (
                                                    <tr>
                                                        <td colSpan={5} className="text-center text-muted py-4">No employees found.</td>
                                                    </tr>
                                                )}
                                                {employees.map((e) => (
                                                    <tr key={e.id}>
                                                        <td className="rt-name">{e.employee_number ?? '—'}</td>
                                                        <td>{e.name ?? '—'}</td>
                                                        <td>{e.surname ?? '—'}</td>
                                                        <td>{e.email ?? '—'}</td>
                                                        <td className="rt-actions text-end">
                                                            <button
                                                                className="btn btn-sm btn-primary"
                                                                onClick={() => navigate(`/reviews/team/${e.id}`)}
                                                            >
                                                                Open
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <div className="text-muted small">
                                                Page {meta.current_page} of {meta.last_page} • Total {meta.total}
                                            </div>
                                            <div className="d-flex gap-2">
                                                <button
                                                    className="btn btn-sm btn-outline-secondary"
                                                    disabled={!canPrev}
                                                    onClick={() => canPrev && setPage(p => p - 1)}
                                                >
                                                    Prev
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-outline-secondary"
                                                    disabled={!canNext}
                                                    onClick={() => canNext && setPage(p => p + 1)}
                                                >
                                                    Next
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>

                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}
